module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGCAMAAAAi7JTKAAAAYFBMVEUAAAA9PT2PIo+YJpiVJZWDHYNtFG1MC0yAG4CSI5KVJZWFHYVmEmYwBjB/G3+PIo+WJZaIHohtFG1BCUF6GXqPIo+VJZWIHoh1F3VQDFB8GXyDHYNsFGxICkhXDleZJ5n0Z9WnAAAAH3RSTlMAftff3KItG5H6/LA6FpX5/r46IJn3/rk+IJa2NxUpsUip5QAAAAlwSFlzAAAASAAAAEgARslrPgAAADpJREFUCNdjYGRiBgMWVjYGdg5OeSDg4uZhYGDg5eOXlxcQFGIAAWERUTFxCQYIkJSSlmGAAVk5MAUAYd4Cm3/1npUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTctMTItMThUMTQ6MTM6MDgtMDU6MDBfobpfAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE3LTEyLTE4VDE0OjEzOjA4LTA1OjAwLvwC4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/NavLinks/down-arrow.png
// module id = 249
// module chunks = 0